<script>
import { defineComponent } from "vue";
import { Line } from "vue-chartjs";

export default defineComponent({
  name: "lineChart",
  extends: Line,
  props: ["data"],
  data() {
    return {
      options: {
        tooltips: {
          intersect: false,
          displayColors: false,
          mode: "index",
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
                drawTicks: false,
              },
              ticks: {
                maxTicksLimit: 3,
                beginAtZero: true,
                padding: 10,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawBorder: false,
                drawTicks: false,
              },
              ticks: {
                maxTicksLimit: 3,
                beginAtZero: true,
                fontSize: 10,
                padding: 10,
                maxRotation: 0,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
});
</script>
